import { render, staticRenderFns } from "./FttoService.vue?vue&type=template&id=50ef1dea&"
import script from "./FttoService.vue?vue&type=script&lang=js&"
export * from "./FttoService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports